module.exports = __webpack_public_path__ + "ninja-chrome-256x256.png";